import React from 'react';
import styled from 'styled-components';
import { Breakpoints } from '../../app/StyleGuide';
import { TrainingPoster } from '../TrainingElements';
import TrainingPosterPlaceholder from '../../features/training/components/TrainingPosterPlaceholder';
import trainingService from '../../services/trainingService';

const PosterContainer = styled.div`
  grid-column: 1 / -1;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-column: 1;
    display: flex;
    width: 300px;
    min-width: 300px;
    text-align: center;
    align-items: start;
  }
`;

type PosterProps = {
  src?: string;
  fallbackName?: string;
};

export function Poster({ src, fallbackName }: PosterProps) {
  if (src) {
    return (
      <PosterContainer>
        <TrainingPoster src={trainingService.getTrainingImageUrl(src)} />
      </PosterContainer>
    );
  }

  if (fallbackName) {
    return (
      <PosterContainer>
        <TrainingPosterPlaceholder ownerName={fallbackName} />
      </PosterContainer>
    );
  }

  return null;
}
